<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner-list">
        <div class="row mb-4">
            <div class="col-md-6">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">Localizações de estoque</h1>
                        <p class="welcome-message">
                            <button mat-icon-button routerLink="/configuracoes/suprimentos">
                                <mat-icon>arrow_back</mat-icon>
                            </button>
                            Visualize e gerencie suas localizações de estoque.
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-6 header-actions">
                <button mat-stroked-button class="btn-secondary" [matMenuTriggerFor]="opcoesMenu">
                    @if(selection.hasValue()) { <span>Ações ({{selection.selected.length}})</span> } @else {
                    <span>Ações</span> }
                    <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button>
                <mat-menu #opcoesMenu="matMenu">
                    <button mat-menu-item (click)="abrirModalExcluir()" [disabled]="!selection.hasValue()">
                        <mat-icon class="material-symbols-outlined">delete</mat-icon>
                        <span>Excluir selecionadas</span>
                    </button>
                    <button mat-menu-item (click)="abrirModalInativar()" [disabled]="!selection.hasValue()">
                        <mat-icon class="material-symbols-outlined">toggle_off</mat-icon>
                        <span>Inativar selecionadas</span>
                    </button>
                </mat-menu>
                <button type="button" mat-flat-button class="btn-primary"
                    routerLink="/configuracoes/suprimentos/localizacao-estoque/cadastrar">
                    <mat-icon class="material-symbols-outlined">add</mat-icon> Nova localização
                </button>
            </div>
        </div>

        <form [formGroup]="model" (ngSubmit)="clickPesquisar()">
            <div class="row search-area">
                <div class="col-md-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Pesquisar</mat-label>
                        <input matInput type="text" formControlName="pesquisa"
                            placeholder="Busque pelo código ou nome da localização...">
                        <button mat-icon-button matSuffix type="submit"
                            aria-label="Pesquisar"><mat-icon>search</mat-icon></button>
                    </mat-form-field>
                </div>
            </div>
        </form>

        @if(_isLoading && _dataSource.data.length === 0) {
        <app-loading-box-default-list></app-loading-box-default-list>
        } @else if(_dataSource.data.length > 0) {

        <table mat-table class="desktop-view" [dataSource]="_dataSource" matSort>
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef class="w-checkbox">
                    <mat-checkbox (change)="$event ? toggleAllRows() : null"
                        [checked]="selection.hasValue() && isAllSelected()"></mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row" class="w-checkbox">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)"></mat-checkbox>
                </td>
            </ng-container>
            <ng-container matColumnDef="codigo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Código</th>
                <td mat-cell *matCellDef="let element">{{element.codigo}}</td>
            </ng-container>
            <ng-container matColumnDef="nome">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome</th>
                <td mat-cell *matCellDef="let element">{{element.nome}}</td>
            </ng-container>
            <ng-container matColumnDef="isPadrao">
                <th mat-header-cell *matHeaderCellDef class="column-badge-center">Padrão</th>
                <td mat-cell *matCellDef="let element" class="column-badge-center">
                    @if(element.isPadrao) {
                    <span class="status-badge badge-amarelo">Padrão</span>
                    }
                </td>
            </ng-container>
            <ng-container matColumnDef="isAtivo">
                <th mat-header-cell *matHeaderCellDef class="column-badge-center">Status</th>
                <td mat-cell *matCellDef="let element" class="column-badge-center">
                    @if(element.isAtivo) {
                    <span class="status-badge badge-verde">Ativo</span>
                    } @else {
                    <span class="status-badge badge-cinza">Inativo</span>
                    }
                </td>
            </ng-container>
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
                <td mat-cell *matCellDef="let element" class="text-center w-actions">
                    <button mat-icon-button [matMenuTriggerFor]="menu"><span
                            class="material-symbols-outlined">more_horiz</span></button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item
                            [routerLink]="['/configuracoes/suprimentos/localizacao-estoque/cadastrar', { idLocalizacaoEstoque: element.idLocalizacaoEstoque }]">
                            <span class="material-symbols-outlined">edit</span><span>Editar</span>
                        </button>
                        <button mat-menu-item (click)="tornarPadrao(element)" [disabled]="element.isPadrao">
                            <span class="material-symbols-outlined">star</span><span>Tornar padrão</span>
                        </button>
                        @if(element.isAtivo) {
                        <span matTooltipPosition="right" [matTooltip]="element.isPadrao ? 'A localização padrão não pode ser inativada.' : (element.possuiVinculo ? 'Esta localização está em uso e não pode ser inativada.' : '')">
                            <button mat-menu-item (click)="alterarStatus(element, false)" [disabled]="element.isPadrao || element.possuiVinculo">
                                <span class="material-symbols-outlined">toggle_off</span><span>Inativar</span>
                            </button>
                        </span>
                        } @else {
                        <button mat-menu-item (click)="alterarStatus(element, true)">
                            <span class="material-symbols-outlined">toggle_on</span><span>Ativar</span>
                        </button>
                        }
                        <span matTooltipPosition="right" [matTooltip]="element.isPadrao ? 'A localização padrão não pode ser excluída.' : (element.possuiVinculo ? 'Esta localização está em uso e não pode ser excluída.' : '')">
                            <button mat-menu-item (click)="abrirModalExcluir(element)" [disabled]="element.isPadrao || element.possuiVinculo">
                                <span class="material-symbols-outlined">delete</span><span>Excluir</span>
                            </button>
                        </span>
                    </mat-menu>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <div class="mobile-view">
            @for (item of _dataSource.data; track item.idLocalizacaoEstoque) {
            <div class="card-mobile mb-3" [class.selected-card]="selection.isSelected(item)">
                <div class="card-header-mobile d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center gap-2">
                        <mat-checkbox (change)="$event ? selection.toggle(item) : null"
                            [checked]="selection.isSelected(item)" color="primary"></mat-checkbox>
                        <div class="d-flex flex-column">
                            <span class="text-bold">{{item.codigo}} - {{item.nome}}</span>
                            <div class="d-flex gap-2 mt-1">
                                @if(item.isPadrao) { <span class="status-badge badge-amarelo">Padrão</span> }
                                @if(item.isAtivo) { <span class="status-badge badge-verde">Ativo</span> } @else { <span
                                    class="status-badge badge-cinza">Inativo</span> }
                            </div>
                        </div>
                    </div>
                    <button mat-icon-button [matMenuTriggerFor]="menuMobile"><span
                            class="material-symbols-outlined">more_horiz</span></button>
                    <mat-menu #menuMobile="matMenu">
                        <button mat-menu-item
                            [routerLink]="['/configuracoes/suprimentos/localizacao-estoque/cadastrar', { idLocalizacaoEstoque: item.idLocalizacaoEstoque }]">Editar</button>
                        <button mat-menu-item (click)="tornarPadrao(item)" [disabled]="item.isPadrao">Tornar
                            padrão</button>
                        @if(item.isAtivo) {
                        <span matTooltipPosition="right" [matTooltip]="item.isPadrao ? 'A localização padrão não pode ser inativada.' : (item.possuiVinculo ? 'Esta localização está em uso e não pode ser inativada.' : '')">
                            <button mat-menu-item (click)="alterarStatus(item, false)"
                                [disabled]="item.isPadrao || item.possuiVinculo">Inativar</button>
                        </span>
                        } @else {
                        <button mat-menu-item (click)="alterarStatus(item, true)">Ativar</button>
                        }
                        <span matTooltipPosition="right" [matTooltip]="item.isPadrao ? 'A localização padrão não pode ser excluída.' : (item.possuiVinculo ? 'Esta localização está em uso e não pode ser excluída.' : '')">
                            <button mat-menu-item (click)="abrirModalExcluir(item)"
                                [disabled]="item.isPadrao || item.possuiVinculo">Excluir</button>
                        </span>
                    </mat-menu>
                </div>
            </div>
            }
        </div>

        <div class="col-12 text-center mt-4 mb-5">
            <button mat-button class="btn-ver-mais"
                [disabled]="_isLoading || _dataSource.data.length >= _totalRegistros" (click)="proximaPagina()">
                @if (_isLoading) { <mat-spinner [diameter]="20"></mat-spinner> } @else { <span
                    class="material-symbols-outlined">expand_more</span> Ver Mais }
            </button>
        </div>

        } @else {
        <app-empty-list [title]="'Nenhuma localização encontrada'"
            [subTitle]="'Adicione uma nova localização para começar'"></app-empty-list>
        }
    </div>
</div>